/**
 * EvidenceRulesTour — 3-step on-ramp for /admin/warranty/evidence-rules.
 */
import TourOverlay from "@/components/TourOverlay";

const STEPS = [
  {
    id: "new-rule",
    selector: '[data-testid="evidence-rule-new"]',
    placement: "below-end",
    title: "Create a new rule",
    body: "Each rule maps a defect category (e.g. oil_leak) to keywords + AI coaching instructions + minimum required evidence. The AI agent runs every active rule against the user's findings.",
  },
  {
    id: "mine-logs",
    selector: '[data-testid="evidence-rule-suggestions"]',
    placement: "below-end",
    title: "Mine claim logs",
    body: "Surfaces the most-frequent words from real claim findings that NO rule covers yet. Click a chip to open the New Rule modal pre-filled with that keyword.",
  },
  {
    id: "rules-list",
    selector: '[data-testid="evidence-rules-list"]',
    placement: "above",
    title: "Rule list",
    body: "Each card shows the category key, keywords, AI instructions, and required evidence. Edit or Delete from the action bar at the bottom of each card.",
    optional: true,
  },
  {
    id: "done",
    selector: null,
    placement: "center",
    title: "You're set.",
    body: "Pro tip: hover any chat message in a warranty conversation and click \"Make rule\" to pre-fill the New Rule modal from that message body. Reset this tour: localStorage.removeItem('evidence_rules_tour_seen_v1').",
  },
];

export default function EvidenceRulesTour() {
  return (
    <TourOverlay
      storageKey="evidence_rules_tour_seen_v1"
      bannerTitle="First time on Evidence Rules?"
      bannerCopy="Take the 30-second tour — New rule, Mine claim logs, and the rule card layout in 3 steps."
      bannerTone="amber"
      testIdPrefix="evidence-rules-tour"
      steps={STEPS}
    />
  );
}
